import script from "./SellerLiveOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerLiveOrders.vue?vue&type=script&setup=true&lang=ts"

import "./SellerLiveOrders.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__